import React, { FC, useMemo } from 'react'
import {
  BiLogoGithub,
  BiLogoLinkedin,
} from 'react-icons/bi'
import { CgNpm } from 'react-icons/cg'
import { HiOutlineMail } from 'react-icons/hi'
import * as app from '../styles/App.styled'
import * as bio from '../styles/Bio.styled'
import profile_pic from '../assets/profile_pic.jpeg'
import SlideInMotion, {
  SlideInDirection,
} from './SlideInMotion'

export const Bio: FC = () => {
  const { left, right } = SlideInDirection

  const statement = useMemo<string>(() => {
    return (
      'I am a software engineer with over a decade of experience specializing ' +
      'in full-stack web application development, cloud deployment, and database design. I ' +
      'enjoy designing and developing web applications to streamline workflows and visualize ' +
      'complex data. My approach is rooted in incorporating the latest technologies and ' +
      'methodologies to deliver efficient, effective, custom software solutions.'
    )
  }, [])

  const iconSize = useMemo<string>(() => {
    const size:number = 4.2

    return `${size}em`
  }, [])

  const emailIconMargin = useMemo<string>(() => {
    const margin:number = 0.2

    return `${margin}em`
  }, [])

  return (
    <app.StyledSection>
      <app.StyledCardSmallDarkBlack>
        <app.StyledText>{statement}</app.StyledText>
      </app.StyledCardSmallDarkBlack>
      <app.StyledCardLargeLightBlack>
        <SlideInMotion direction={left}>
          <bio.StyledProfilePic
            src={profile_pic}
            alt='profile_pic'
          />
        </SlideInMotion>
        <SlideInMotion direction={right}>
          <bio.StyledLinkContainer>
            <app.StyledLink
              href='mailto:dkontro.dk@gmail.com'
            >
              <HiOutlineMail
                size={iconSize}
                style={{
                  marginTop: `${emailIconMargin}`,
                  marginBottom: `-${emailIconMargin}`,
                }}
              />
            </app.StyledLink>
            <app.StyledLink
              href='https://www.linkedin.com/in/david-kontrovitz-4353356b'
              target='_blank'
            >
              <BiLogoLinkedin size={iconSize} />
            </app.StyledLink>
            <app.StyledLink
              href='https://github.com/daveKontro'
              target='_blank'
            >
              <BiLogoGithub size={iconSize}/>
            </app.StyledLink>
            <app.StyledLink
              href='https://www.npmjs.com/~davekontro'
              target='_blank'
            >
              <CgNpm size={iconSize} />
            </app.StyledLink>
          </bio.StyledLinkContainer>
        </SlideInMotion>
      </app.StyledCardLargeLightBlack>
    </app.StyledSection>
  )
}
